import React from 'react'
import ReactDOM from 'react-dom'
import Modal from '../components/Modal';
import ImageGallery from '../components/ImageUploader/ImageGallery';

const ImageGridContainer = () => {
  const elements = document.querySelectorAll('.js-generate-images-from-api')

  async function handleClick(e) {
    e.preventDefault()
    openModal()
  }
  function onClose() {
    ReactDOM.unmountComponentAtNode(document.querySelector('.js-modal'))
  }
  function openModal() {
    ReactDOM.render(
      <Modal isOpen={true} onClose={onClose}>
        <ImageGallery/>
      </Modal>,
      document.querySelector('.js-modal')
    )
  }

  elements.forEach(element => {
    ReactDOM.render(
      <a onClick={(e) => handleClick(e)} className="button--success"> Find pictures via API</a>,
      element
    )
  })
}

export default ImageGridContainer;
